// @ts-nocheck
import FirebaseNodeV3 from '../../../../components/v3/base/FirebaseNode'
import {
  cloneVDom,
  fixBlocksObjectData,
} from '../../../../components/v3/lib/vue-dom-obj'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'
import { Notification } from 'element-ui'
import * as getters from '../../../../store/modules/getters'
import * as actions from '../../../../store/modules/actions'
import * as mutations from '../../../../store/modules/mutations'
import {ConvrrtFirebase} from "../../../../convrrt-firebase";
import Block from '../../../../components/v3/editor/nodes/Block.vue'
import FbVNode from '../../../../components/base/FbVNode.vue'

export default FbVNode.extend({
  name: 'SlideEngineV3',
  mixins: [FirebaseNodeV3],
  components: {
    block: Block,
  },
  async beforeRouteLeave(to, from, next) {
    try {
      this.toggleAdvancedMenu(false)
      this.toggleLeftSideMenu({ open: false })
      this.setViewMode('desktop')
      this.deselect()
      this.ignore()
      next()
    } catch (err) {
      console.error('beforeRouteLeave error', err)
      next(false)
    }
  },

  props: {
    // usually passed from router
    popup: {
      type: Object,
      required: true,
    },
    rootPath: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      name: 'PageEngine',
      clonedVDom: [],
      blockVnodeId: null,
    }
  },
  computed: {
    ...mapGetters({
      cPopupData:getters.SDA_POPUP_FIREBASE_DATA,
      vdom: getters.DELTA_VDOM,
      step: getters.STEPS_CURRENT_STEP,
      viewMode: getters.VIEW_MODE,
      canUndo: getters.COMMAND_CAN_UNDO,
      canRedo: getters.COMMAND_CAN_REDO,
    }),
    styles () {
      return {
        'min-height': this.cPopupData.data.props.popupHeight? this.cPopupData.data.props.popupHeight: '50%',
        'height': this.cPopupData.data.props.popupHeight? this.cPopupData.data.props.popupHeight: 'auto',
        width: this.cPopupData.data.props.popupWidth? this.cPopupData.data.props.popupWidth: '60%',
      }
    }
  },
  watch: {
    viewMode: {
      handler(newVal) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.$mount()
            this.clonedVDom = [...this.clonedVDom]
          })
        }, 200)
      },
    },
    vdom: {
      handler(newVal) {
        this.clonedVDom = [...this.clonedVDom]
      }
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => setTimeout(vm.initVdom, 500))
  },

  async beforeRouteUpdate(to, from, next) {
    try {
      this.startLoader('Switching Pages')
      setTimeout(this.initVdom, 500)
      next()
    } catch (err) {
      console.debug('beforeRouteUpdate error', err)
      next(false)
    }
  },

  methods: {
    ...mapMutations({
      ignore: mutations.SELECTOR_IGNORE,
      setQuickLaunchEngine: mutations.QUICK_LAUNCH_BLOCK_SET_PAGE_ENGINE,
      setViewMode: mutations.VIEW_MODE_SET,
    }),
    ...mapActions({
      deltaInit: actions.DELTA_INIT,
      markStep: actions.STEPS_MARK,
      updateSiteThumbnail: actions.SITE_UPDATE_THUMBNAIL,
      toggleAdvancedMenu: actions.ADVANCED_MENU_TOGGLE,
      toggleLeftSideMenu: actions.LEFT_SIDE_MENU_TOGGLE,
      initLayout: actions.LAYOUT_INIT,
      undo: actions.HISTORY_COMMAND_UNDO,
      redo: actions.HISTORY_COMMAND_REDO,
      setBuilderVersion: actions.SET_BUILDER_VERSION,
    }),

    ...mapMutations('loader', {
      setLoaderMsg: 'setMessage',
    }),

    ...mapActions('loader', {
      startLoader: 'start',
    }),
    mouseOverTarget (event) {
      document.getElementById(`${this.blockVnodeId}`)?.dispatchEvent(
          new MouseEvent('mouseover', { 'bubbles': true })
      )
      event.stopPropagation()
    },
    blockTargetClick (event) {
      document.getElementById(`${this.blockVnodeId}`)?.dispatchEvent(
          new Event('click', { 'bubbles': true })
      )
      event.stopPropagation()
    },
    snapshotWrapper (value) {
      return {
        val: () => {
          return value
        }
      }
    },
    initVdom() {
      this.deltaInit({
        key: this.rootPath,
      })

      this.initLayout({
        pageEngine: this,
      })

      this.setQuickLaunchEngine({
        pageEngine: this,
      })

      this.setBuilderVersion('v3')
      this.firebaseRef().ref.once('value', (snapshot) => {
        const cPopupData = snapshot.val()
        const nodeBlocks = fixBlocksObjectData(
            new ConvrrtFirebase(this.rootPath), this.snapshotWrapper(cPopupData.children)
        )
        this.clonedVDom = cloneVDom(nodeBlocks, this.rootPath)
        this.blockVnodeId = cPopupData.children[0]?.data?.props?.vnodeId
      })
    },
  },
})
